module.exports = __webpack_public_path__ + "static/media/square_profile.b42cec70.png";